import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CompanyRequest, NewCompanyRequest } from '../models/company.model';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  private URL = environment.api + "api/company";
  private URL_ERP = environment.api + "api/erp/company";
  constructor(
    private http: HttpClient
  ) { }

  getAllCompanies() {
    return this.http.get(this.URL + "/all-active");
  }

  getActivities() {
    return this.http.get(this.URL + "/activities/name");
  }

  getTrial() {
    return this.http.get(this.URL + "/trial");
  }

  createCompany(newCompany: CompanyRequest) {
    return this.http.post(this.URL + "/create", newCompany);
  }

  checkNIT(nit: string) {
    return this.http.get(this.URL + "/verifynit/" + nit);
  }

  getNitEDX(nit: string) {
    return this.http.get(this.URL + "/nitEdx/" + nit);
  }

  /**
   * 
   * @returns an Response Object that in data carry the CompanyPackageResponse
   */
  getPackages() {
    return this.http.get(this.URL + "/packages/consumer");
  }

  getAllConfig() {
    return this.http.get(this.URL_ERP + "/config/all/list");
  }

  changeConfig(idConfig, valueConfig) {
    return this.http.post(this.URL_ERP + `/config?config=${idConfig}&value=${valueConfig}`, {})
  }

  getAllUsers(search: string) {
    return this.http.get(this.URL + "/availableUsers", {
      params: {
        search: search
      }
    });
  }

  saveCompanyRequest(request: NewCompanyRequest) {
    return this.http.post(this.URL + "/application", request);
  }

  getEventsNearly() {
    return this.http.get(this.URL + "/events/nearly");
  }

  getEventById(id: number) {
    return this.http.get(this.URL + "/events", {
      params: {
        id: id
      }
    });
  }

  getApplicationEvents() {
    return this.http.get(this.URL + "/application/events", {
      params: {
        "application": 0
      }
    });
  }

  getPaginationApplication(onlyPending, page, size) {
    return this.http.get(this.URL + "/application/pagination", {
      params: {
        onlyPending: onlyPending,
        page: page,
        size: size
      }
    });
  }

  getPaginationCompaiesPassword(filter, page, size, user, isPartner = false) {
    return this.http.get(this.URL + "/passwordSat" + (isPartner ? 'Admin' : '') + "/companies", {
      params: {
        filter: filter,
        page: page,
        size: size,
        user: user
      }
    });
  }

  getPaginationCompaiesDateDte(filter, page, size, user, isPartner = false) {
    return this.http.get(this.URL + "/dateDte" + (isPartner ? 'Admin' : '') + "/companies", {
      params: {
        filter: filter,
        page: page,
        size: size,
        user: user
      }
    });
  }

  saveDateDte(dateDteRequest, isPartner = false) {
    return this.http.post(this.URL + "/dateDte" + (isPartner ? 'Admin' : ''), dateDteRequest);
  }

  savePasswordSat(passwordRequest, isPartner = false) {
    return this.http.post(this.URL + "/passwordSat" + (isPartner ? 'Admin' : ''), passwordRequest);
  }

  getPasswordSatByCompany(company, isPartner = false) {
    return this.http.get(this.URL + "/passwordSat" + (isPartner ? 'Admin' : ''), {
      params: {
        company: company
      }
    });
  }

  getPaginationCompaniesNoAssociated(
    filter: string,
    page: number = 0,
    size: number = 5
  ) {
    return this.http.get(this.URL + "/notAssociated", {
      params: {
        filter: filter,
        page: page,
        size: size
      }
    });
  }

  getPaginationCompaniesIsAssociated(
    filter: string,
    page: number = 0,
    size: number = 5
  ) {
    return this.http.get(this.URL + "/isAssociated", {
      params: {
        filter: filter,
        page: page,
        size: size
      }
    });
  }

  getCompaniesAssociatedToPartner(
    partner: number
  ) {
    return this.http.get(this.URL + "/associated", {
      params: {
        partner: partner
      }
    });
  }

  associateToPartner(
    company: number,
    partner: number
  ) {
    return this.http.put(this.URL + `/associate?company=${company}&partner=${partner}`, null);
  }

  getPartnerCompany(id: any) {
    return this.http.get(this.URL + `/associated/company?companyId=${id}`);
  }

  deleteAssociation(
    company: number
  ) {
    return this.http.delete(this.URL + `/associate?company=${company}`);
  }

  deactivatePasswordSAT(
    company: number
  ) {
    return this.http.post(this.URL + `/deactivatePasswordSat/${company}`, null);
  }

  getClosures(year: number) {
    return this.http.get(this.URL_ERP + "/closures", {
      params: {
        year: year
      }
    });
  }

  validateLastClosing() {
    return this.http.get(this.URL_ERP + "/last/closure");
  }

  performClosing(month: number, year: number) {
    return this.http.post(this.URL_ERP + `/close?month=${month}&year=${year}`, null);
  }

  getConfigVerifyInventory(){
    return this.http.get(this.URL_ERP + `/config/inventory-existence`);
  }

  checkCompanyConfigTokenAlpha(){
    return this.http.get(this.URL_ERP + `/config/token-alpha`);
  }

  checkCompanyConfigPolicy(){
    return this.http.get(this.URL_ERP + `/config/policy`);
  }

  checkCompanyConfigListOwnProducts(){
    return this.http.get(this.URL_ERP + `/config/list-own-products`);
  }

  checkCompanyConfigGeographicMap(){
    return this.http.get(this.URL_ERP + `/config/geographic-map`);
  }

  checkCompanyConfigAdministration(){
    return this.http.get(this.URL_ERP + `/config/administration`);
  }

  checkCompanyConfigRegularExtraTax(){
    return this.http.get(this.URL_ERP + `/config/regular-extra-tax`);
  }

  checkCompanyConfigProductsFavorite(){
    return this.http.get(this.URL_ERP + `/config/regular-extra-tax`);
  }

  checkCompanyConfigAdministrative(){
    return this.http.get(this.URL_ERP + `/config/administrative`);
  }
}